import { REWARD_TYPE } from '@constants/tournamentConstants'

const BAR_CLASS = { 1: 'one', 2: 'two', 3: 'three' }

// Pure render — one top-3 gradient bar. `pointsLabel` and `showReward` are
// pre-derived by the tab (tournament type -> "Bets"/currency, origin -> FREEBET/AMOUNT).
const LeaderboardBar = ({ rank, player, pointsLabel, showReward }) => (
  <div className={`standard-normal-leaderboard-bar standard-normal-leaderboard-bar-${BAR_CLASS[rank]}`}>
    <div
      className={`standard-normal-leaderboard-bar-position ${player.isMe ? 'standard-normal-leaderboard-bar-position-me' : ''}`}
    >
      {rank}
    </div>

    <div className="standard-normal-leaderboard-bar-details">
      <div className="standard-normal-leaderboard-bar-playerid">{player.playerId}</div>
      <div className="standard-normal-leaderboard-bar-points">
        <span className="standard-normal-leaderboard-bar-points-value">{player.points}</span>
        <span className="standard-normal-leaderboard-bar-points-label">{pointsLabel}</span>
      </div>
      {showReward && player.rewardType === REWARD_TYPE.FREEBET && player.freeBets > 0 && (
        <div className="standard-normal-leaderboard-bar-reward">{player.freeBets} Freebets</div>
      )}
      {showReward && player.rewardType === REWARD_TYPE.AMOUNT && (
        <div className="standard-normal-leaderboard-bar-reward">{player.reward}</div>
      )}
    </div>
  </div>
)

export default LeaderboardBar
